<ng-template #simpleFleetHeader let-theFleet="theFleet">
  <div id="_Header-Fleet-Extra_" class="w-full ml-4 ism-white text-1.25 flex items-center">
    <div data-tooltip="Fleet Name" class="py-2 font-bold tooltip-tr">{{ theFleet?.fleetName }}</div>
    <div data-tooltip="Ship Count" class="py-2 mx-4 text-center ism-white tooltip-tr">{{ theFleet?.shipIds?.length }} ships</div>
  </div>
</ng-template>

<ng-template #fleetShipList let-theFleet="theFleet" let-action="action">
  <div class="w-full">
    @if (theFleet?.ships?.length > 0) {
      <table class="ml-4 w-fit ism-white border">
        <tr>
          <th class="text-left border border-separate bg-gray-800 bg-opacity-85">Ship Name</th>
          @if (action === "buy") {
            <th class="text-right border border-separate bg-gray-800 bg-opacity-85">Purchase Price</th>
            <th class="text-right border border-separate bg-gray-800 bg-opacity-85">Maintenance</th>
          }
          <!-- -->
          @else if (action === "vacate") {
            <!-- <th class="border border-separate bg-gray-800 bg-opacity-85">Vacate Lease</th> -->
          }
          <!-- -->
          @else if (action === "activate") {
            <th class="text-right border border-separate bg-gray-800 bg-opacity-85">Activation Fee</th>
          }
          <!-- -->
          @else {
            <th class="text-right border border-separate bg-gray-800 bg-opacity-85">Sale Price</th>
            <th class="text-right border border-separate bg-gray-800 bg-opacity-85">Maintenance</th>
          }
          <!-- -->
          <th class="text-center border border-separate bg-gray-800 bg-opacity-85">Action</th>
        </tr>
        @for (ship of theFleet?.ships; track ship) {
          <tr class="data-odd-light">
            @let shipClass = shipClassById[ship.shipClassId];
            @let shipTransaction = transactionByShipId[ship._id] || undefined;
            <td class="text-left">
              {{ ship.shipName }}
              <span class="hidden">{{ ship._id }}</span>
              <span class="hidden">{{ shipTransaction | json }}</span>
            </td>
            @if (action === "buy") {
              <td class="text-right">{{ shipClass.buildCost | number: "1.1-1" }} MC</td>
              <td class="text-right">{{ shipClass.maintenanceCost | number: "1.1-1" }} MC</td>
              @if (shipTransaction) {
                <td class="text-center">
                  <button class="" (click)="buy(ship)">
                    <ism-svg [name]="'pencilSquare'"></ism-svg>
                  </button>
                  <button class="" (click)="delete(ship)">
                    <ism-svg [name]="'xSquare'"></ism-svg>
                  </button>
                </td>
              }
              <!-- -->
              @else {
                <td class="text-center"><button (click)="buy(ship)" class="mx-2 px-2 btn">Buy</button></td>
              }
            }
            <!-- -->
            @else if (action === "vacate") {
              @if (shipTransaction) {
                <td class="text-center">
                  <button class="" (click)="vacateLease(ship)">
                    <ism-svg [name]="'pencilSquare'"></ism-svg>
                  </button>
                  <button class="" (click)="delete(ship)">
                    <ism-svg [name]="'xSquare'"></ism-svg>
                  </button>
                </td>
              }
              <!-- -->
              @else {
                <td class="text-center">
                  <button (click)="vacateLease(ship)" class="mx-2 px-2 btn">Vacate Lease</button>
                </td>
              }
            }
            <!-- -->
            @else if (action === "activate") {
              <td class="text-right">{{ shipClass.maintenanceCost * 3 | number: "1.1-1" }} MC</td>
              @if (shipTransaction) {
                <td class="text-center">
                  <button class="" (click)="activate(ship)">
                    <ism-svg [name]="'pencilSquare'"></ism-svg>
                  </button>
                  <button class="" (click)="delete(ship)">
                    <ism-svg [name]="'xSquare'"></ism-svg>
                  </button>
                </td>
              }
              <!-- -->
              @else {
                <td class="text-center">
                  <button (click)="activate(ship)" class="mx-2 px-2 btn">Activate</button>
                </td>
              }
            }
            <!-- -->
            @else if (action === "race") {
              <td class="text-right">{{ shipClass.buildCost * 0.9 | number: "1.1-1" }} MC</td>
              <td class="text-right">{{ shipClass.maintenanceCost | number: "1.1-1" }} MC</td>
              @if (shipTransaction) {
                <td class="text-center">
                  <button class="" (click)="delete(ship)">
                    <ism-svg [name]="'xSquare'"></ism-svg>
                  </button>
                </td>
              }
              <!-- -->
              @else {
                <td class="text-center">
                  @if (ship.certified) {
                    <button (click)="sell(ship)" class="mx-2 px-2 btn">Sell</button>
                    <button (click)="lease(ship)" class="mx-2 px-2 btn">Lease</button>
                  }
                  @if (syBySystemHex[theFleet.starSystemId + theFleet.locationHex] || false) {
                    <button (click)="mothball(ship)" class="mx-2 px-2 btn">Mothball</button>
                  }
                </td>
              }
            }
          </tr>
        }
      </table>
    }
  </div>
</ng-template>

<h1>Ahmed's Used Space Freighters</h1>
<p>Our sector has the best, gently used space freighters.</p>
<p>We buy your gently used space freighters.</p>
<p>We have great lease terms too!</p>
<p></p>
<div>
  <div class="w-full py-2 ism-gold text-1.25 flex items-center">
    <div class="px-4" (click)="setExtraPool()">Extra CFN Pool ({{ extraPool()?.shipIds?.length }} ships)</div>
    <div class="px-4" (click)="setGovernmentPool()">Leased CFN Pool ({{ governmentPool()?.shipIds?.length }} ships)</div>
    <div class="px-4" (click)="setMothballedFleet()">Mothballed Fleet ({{ mothballedFleet()?.shipIds?.length }} ships)</div>
    <div class="px-4" (click)="setRaceFleets()">Race Fleets</div>
  </div>
  @switch (selectedTab()) {
    @case ("extraPool") {
      <!-- Extra Pool (fleet / sold to the CFN) -->
      <ng-container [ngTemplateOutlet]="simpleFleetHeader" [ngTemplateOutletContext]="{ theFleet: extraPool() }"></ng-container>
      <ng-container [ngTemplateOutlet]="fleetShipList" [ngTemplateOutletContext]="{ theFleet: extraPool(), action: action }"></ng-container>
    }
    @case ("governmentPool") {
      <!-- Government Pool (fleet / leased to the CFN) -->
      <ng-container [ngTemplateOutlet]="simpleFleetHeader" [ngTemplateOutletContext]="{ theFleet: governmentPool() }"></ng-container>
      <ng-container [ngTemplateOutlet]="fleetShipList" [ngTemplateOutletContext]="{ theFleet: governmentPool(), action: action }"></ng-container>
    }
    @case ("mothballedFleet") {
      <!-- Mothballed Fleet -->
      <ng-container [ngTemplateOutlet]="simpleFleetHeader" [ngTemplateOutletContext]="{ theFleet: mothballedFleet() }"></ng-container>
      <ng-container [ngTemplateOutlet]="fleetShipList" [ngTemplateOutletContext]="{ theFleet: mothballedFleet(), action: action }"></ng-container>
    }
    @case ("raceFleets") {
      <div class="sticky mt-2 ml-4 z-10 top-[3px] bg-black bg-opacity-60 ism-accordion-border">
        <div class="w-full pl-2 py-2 sticky z-10 top-[3px] ism-gold text-1.125 font-bold tracking-wider bg-black bg-opacity-60 flex items-center justify-between">
          <div class="text-left">Fleet Name</div>
          <div class="flex justify-end">
            <div class="min-w-20 text-center">System</div>
            <div class="min-w-20 text-center">[ Hex ]</div>
            <div class="min-w-16 text-center">Ships</div>
          </div>
        </div>
      </div>
      <cdk-accordion class="ml-4 relative ism-accordion ism-accordion-border scrollbar-none">
        @for (fleet of fleets(); track $index) {
          @let hexes = hexesForStarSystemId(fleet.starSystemId);
          <cdk-accordion-item class="ism-accordion-item ism-accordion-border" [ngClass]="{ amk: $index % 2 == 0 && !accordionRaceFleets.expanded }" #accordionRaceFleets="cdkAccordionItem" role="button" [attr.id]="'header-race-' + $index" [attr.aria-expanded]="accordionRaceFleets.expanded" [attr.aria-controls]="'body-race-' + $index" [scrollToTop] [offset]="272">
            <div id="_Header-Fleet-Race_" class="w-full font-bold text-1.25 ism-white flex items-center justify-between" (click)="accordionRaceFleets.toggle()">
              <div id="_Header-Chevron-Race_" class="py-2 flex items-center">
                <chevron-toggle [isOpen]="accordionRaceFleets.expanded" [classString]="'w-5 h-5  flex items-center ism-gold'"></chevron-toggle>
                <div data-tooltip="Fleet Name" class="text-clip tooltip-tr">{{ fleet.fleetName }}</div>
              </div>
              <div id="_Header-Detail-Race_" class="flex justify-end">
                <div class="text-left">Terminals at {{ hexes }}</div>
                <div data-tooltip="Star System ID" class="min-w-20 text-center tooltip-tl">{{ starSystemsById[fleet.starSystemId]?.number }}</div>
                <div data-tooltip="System Hex" class="min-w-20 text-center tooltip-tr">[ {{ fleet.locationHex }} ]</div>
                <div data-tooltip="Ship Count" class="min-w-16 text-center tooltip-tr">{{ fleet.shipIds?.length }}</div>
              </div>
            </div>

            <div id="_Detail-Fleet_" role="region" [style.display]="accordionRaceFleets.expanded ? '' : 'none'" [attr.id]="'body-race-' + $index" [attr.aria-labelledby]="'header-race-' + $index">
              <ng-container [ngTemplateOutlet]="fleetShipList" [ngTemplateOutletContext]="{ theFleet: fleet, action: action }"></ng-container>
            </div>
          </cdk-accordion-item>
        }
      </cdk-accordion>
    }
  }
  <div class="mt-4 ml-4">
    <p>* Only CFN Certified Freighters can be bought and sold and only at Terminals.</p>
    <p>* A ship can only be Mothballed at a Terminal that could have it build it.</p>
  </div>
</div>
